import { ReactNode } from "react";

import { Box, type BoxProps } from "@chakra-ui/react";

interface ConditionalWrapProps extends BoxProps {
  condition: boolean;
  children: ReactNode;
}

function ConditionalWrap(props: ConditionalWrapProps): JSX.Element {
  const { as, condition, children, ...rest } = props;

  if (condition) {
    return (
      <Box as={as} {...rest}>
        {children}
      </Box>
    );
  }

  return <>{children}</>;
}

export { ConditionalWrap };
export type { ConditionalWrapProps };
